import React from 'react';
import { MapProvider } from '../../contexts/mapContext';
import { ChoroplethProvider } from 'widgets/choroplethMap/contexts/choroplethContext';
import { ChoroplethMapWidget } from '../ChoroplethMapWidget';

export function ChoroplethMapWrapper({ data, endpointQuery }) {
	return (
		<MapProvider>
			<ChoroplethProvider>
				<ChoroplethMapWidget data={data} endpointQuery={endpointQuery} />
			</ChoroplethProvider>
		</MapProvider>
	);
}
